import { render, staticRenderFns } from "./VehicleCategoryWizardDialog.vue?vue&type=template&id=6174a5e0&"
import script from "./VehicleCategoryWizardDialog.vue?vue&type=script&lang=ts&"
export * from "./VehicleCategoryWizardDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports